export default "__VITE_ASSET__89197ac1__"